import React from "react";
import ReactDOM from "react-dom";

/* COMPONENTS */
import App from "./components/App";

/* BOOTSTRAP STYLES */
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
